import { QRCodeSVG } from "qrcode.react";
import { Smartphone, Copy } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";

export const PhoneScanDialog = ({ open, onClose }) => {
  const url = `${window.location.origin}/vault?open=camera`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — text it to yourself");
    } catch {
      toast.error("Couldn't copy; long-press the link instead");
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm max-h-[94dvh] overflow-y-auto" data-testid="phone-scan-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl flex items-center gap-2"><Smartphone className="h-5 w-5 text-primary" /> Scan from your phone</DialogTitle>
          <DialogDescription>Open your phone's camera, point it at the code, unlock with your PIN, and the scanner opens. Every shot files straight into this vault.</DialogDescription>
        </DialogHeader>
        <div className="grid place-items-center rounded-2xl border border-border bg-white p-4 sm:p-5" data-testid="phone-scan-qr">
          <QRCodeSVG value={url} size={196} level="M" fgColor="#1C1917" className="h-auto w-full max-w-[196px]" />
        </div>
        <div className="flex items-center gap-2 text-xs min-w-0">
          <code className="flex-1 min-w-0 truncate rounded-md bg-muted px-2 py-1.5 text-muted-foreground" data-testid="phone-scan-url">{url}</code>
          <Button data-testid="phone-scan-copy-btn" size="sm" variant="outline" className="h-8 gap-1.5 rounded-full shrink-0" onClick={copy}><Copy className="h-3.5 w-3.5" /> Copy</Button>
        </div>
        <p className="text-[11px] text-muted-foreground">On a phone already? Tap <span className="font-medium text-foreground">Scan with this camera</span> instead.</p>
      </DialogContent>
    </Dialog>
  );
};
